import { ReactNode } from 'react';
import Layout from 'src/components/Layout';
import Navbar from 'src/components/NavBar';
import EnterReceiptContextProvider from 'src/sections/enter_receipt/EnterReceiptContext';
import EnterReceiptMain from 'src/sections/enter_receipt/EnterReceiptMain';
import ShowScansReceipt from 'src/sections/enter_receipt/ShowScansReceipt';

export interface IDisableStep {
  disableNext: boolean;
  disablePrev: boolean;
}
export interface IModalData {
  title: string | React.ReactElement<any>;
  content: ReactNode;
}

const EnterReceipts = () => (
  <EnterReceiptContextProvider>
    <Navbar title="Enter Receipt" />
    <Layout>
      <ShowScansReceipt main={<EnterReceiptMain />} />
    </Layout>
  </EnterReceiptContextProvider>
);
export default EnterReceipts;
